import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { withRouter, Route, Redirect, Switch } from 'react-router-dom'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import styled, { css } from 'styled-components'
import get from 'lodash/get'

import Preloader from 'pages/preloader'
import TodoLayout from 'pages/todolist'
import TeamLayout from 'pages/teamlist'
import ReportsPage from 'pages/reports'
import SettingsPage from 'pages/settings'
import LoginPage from 'pages/login'
import InviteRequestPage from 'pages/inviteRequestPage'
import InviteAcceptPage from 'pages/inviteAcceptPage'
import NotFound from 'pages/notFound'
import OauthCallback from 'pages/oauthCallback'
import OnboardingPage from 'pages/onboarding'
import ContactSyncCallback from 'pages/incrementalCallback/contact'
import DriveOauthCallback from 'pages/incrementalCallback/drive'
import SlackLandingPage from 'pages/slackLandingPage'

import UpdateVersion from 'version'

import variables from 'assets/styles/variables'

import store from 'store'

const PropsRoute = ({ component: Component, restrict, ...rest }) => {
  const isConnected = get(store.getState(), 'session.id')

  return (
    <Route
      {...rest}
      render={routeProps => {
        if (restrict === 'connected' && !isConnected && rest.path !== '/login') {
          return (
            <Redirect
              to={{
                pathname: '/login',
                state: { from: routeProps.location },
                search: ''
              }}
            />
          )
        } else if (restrict === 'publicOnly' && isConnected && rest.path !== '/') {
          return (
            <Redirect
              to={{
                pathname: '/',
                state: { from: routeProps.location }
              }}
            />
          )
        }
        return <Component key={rest.path} {...routeProps} />
      }}
    />
  )
}

const mapStateToProps = state => ({
  session: state.session
})

const parentRoutes = {
  '/index.html': '/',
  '/archive': '/',
  '/focusview': '/',
  '/calendar': '/',
  '/calendar/week': '/',
  '/calendar/month': '/',
  '/team/archive': '/team'
}

class Router extends PureComponent {
  render() {
    if (!this.props.session.loaded) {
      return <Preloader />
    }

    /* use root path to avoid transition between nested routes (example with /team & /team/archive) */
    let pathname = this.props.location.pathname
    if (parentRoutes[pathname]) {
      pathname = parentRoutes[pathname]
    }

    return (
      <Content className="content" isConnected={this.props.session.id}>
        <UpdateVersion>
          <TransitionGroup className={'transition-group'}>
            <CSSTransition
              key={pathname}
              timeout={{ enter: 400, exit: 400 }}
              appear={true}
              mountOnEnter={true}
              unmountOnExit={true}
              classNames={'page-transition'}>
              <PageContainer isConnected={this.props.session.id}>
                <Switch location={this.props.location}>
                  <PropsRoute path="/team" restrict="connected" component={TeamLayout} />
                  <PropsRoute exact path="/reports" restrict="connected" component={ReportsPage} />
                  <PropsRoute exact path="/settings" restrict="connected" component={SettingsPage} />
                  <PropsRoute exact path="/login" restrict="publicOnly" component={LoginPage} />
                  <PropsRoute exact path="/oauthcallback" component={OauthCallback} />
                  <PropsRoute exact path="/onboarding" restrict="connected" component={OnboardingPage} />
                  <PropsRoute exact path="/contactsynccallback" restrict="connected" component={ContactSyncCallback} />
                  <PropsRoute exact path="/driveoauthcallback" restrict="connected" component={DriveOauthCallback} />
                  <PropsRoute exact path="/invite-request" restrict="publicOnly" component={InviteRequestPage} />
                  <PropsRoute path="/invite-accept" restrict="publicOnly" component={InviteAcceptPage} />
                  <PropsRoute path="/slack/landing-page" component={SlackLandingPage} />
                  <PropsRoute path="/" restrict="connected" component={TodoLayout} />
                  <Route component={NotFound} />
                </Switch>
              </PageContainer>
            </CSSTransition>
          </TransitionGroup>
        </UpdateVersion>
      </Content>
    )
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    null,
    null,
    {
      pure: true
    }
  )(Router)
)

const Content = styled.div`
  ${({ isConnected }) =>
    isConnected &&
    css`
      position: relative;
      height: 100%;
      max-width: ${variables.pageMaxWidth};
      margin: auto;
      @media only screen and (max-width: 1450px) {
        max-width: ${variables.pageMaxWidthSmallScreen};
      }
    `}
`

export const PageContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  ${({ isConnected }) =>
    !isConnected &&
    css`
      bottom: 0;
    `}
  &.page-transition-enter-done {
    opacity: 1;
  }

  &.page-transition-appear {
    transition: opacity 0.2s;
    opacity: 0;
  }

  &.page-transition-appear.page-transition-appear-active {
    opacity: 1;
  }

  &.page-transition-enter {
    opacity: 0;
  }

  &.page-transition-enter.page-transition-enter-active {
    opacity: 1;
    transition: opacity 0.2s 0.2s ease-in;
  }

  &.page-transition-exit {
    opacity: 1;
  }

  &.page-transition-exit.page-transition-exit-active {
    opacity: 0;
    transition: opacity 0.2s ease-in;
  }
`



// WEBPACK FOOTER //
// ./src/router.js